module.exports = __webpack_public_path__ + "@/assets/img/koku-cam-digi.48735c4b.jpeg";